module.exports = __webpack_public_path__ + "static/media/tree.4b382ce4.png";